import { atom } from 'jotai';

export const edgeReferralCodeAtom = atom<string | undefined>(
  process.env.NEXT_PUBLIC_DEFAULT_REFERRAL_CODE || undefined,
);

export const fuulReferralCodeAtom = atom<string | undefined>(undefined);
